import { languageService } from "../../../../Language/language.service";

const dateFormat = "MM-DD-yy";

export const hosReportOffDutyFormSchema = {
  title: languageService("Add Off Duty"),
  id: "hosReportOffDutyFormSchema",
  stateTitle: {
    create: languageService("Add Off Duty"),
    delete: languageService("Delete Off Duty"),
  },
  sections: [
    {
      id: "dateRangeInfoSection",
      disabledStates: ["delete"],
      fields: [
        {
          id: "startDate",
          type: "date",
          labelValue: languageService("Start Date"),
          format: dateFormat,
          required: true,
          col: 12,
        },
        {
          id: "endDate",
          type: "date",
          labelValue: languageService("End Date"),
          format: dateFormat,
          required: true,
          col: 12,
        },
        {
          id: "activityTypeCode", // required
          type: "select", // required
          labelValue: languageService("Activity Type"),
          selectOptions: [],
          required: true,
          col: 12,
        },
      ],
    },
    {
      id: "footerActionsSection",
      fields: [
        {
          id: "addOffDuty",
          type: "button",
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addOffDuty",
          position: "footer",
          hiddenStates: ["delete"],
          col: 6,
        },
        {
          id: "confirmDeleteOffDuty",
          type: "button",
          labelValue: languageService("Confirm"),
          action: "submit",
          callback: "confirmDeleteOffDuty",
          position: "footer",
          hiddenStates: ["create"],
          col: 6,
        },
        {
          id: "cancelDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/ReportOffDuty/schemas/hosReportOffDutyFormSchema.js